import React, {useEffect} from 'react';
import { useIntl } from 'react-intl';
import { Modal } from "@ignitesales/neuro-application/src/neuro-ui";
import { NeuroMessage, useNeuroMessages } from '@ignitesales/neuro-application';

const CartModal = ({ className = '', active, onCloseModal, productCart, productCartApply, productCartContact, removeFromCart, openContactForm }) => {
  const intl = useIntl();

  useEffect(() => {
    productCart.length === 0 && productCartApply.length === 0 && productCartContact.length === 0 && active && onCloseModal();
}, [productCart, productCartApply, productCartContact]);

  const messageContext = useNeuroMessages();

  const openProductActionUrl = (productId) => {
    const actionUrl = productId ? messageContext.getMessage(`${productId}.applyUrl`) : null;

    if (actionUrl) {
      const actionLink = document.createElement('a');
      actionLink.href = actionUrl;
      actionLink.target = '_blank';
      actionLink.click();
    }
  }

  const CartSection = ({ titleId, descriptionId, products, actionTextId, removeFromCart, openContactForm, actionButton, applyButton }) => (
    <div className="cart-container">
      <div className={`cart-info  ${actionButton ? "other" : ""}`}>
        <NeuroMessage id={titleId} tagName="h1" />
        <NeuroMessage id={descriptionId} tagName="span" />
      </div>
      <div className="cart-products">
        {products.map(p => (
          <div className="cart-product" key={p.id}>
            <NeuroMessage id={`${p.id}.name`} tagName="h1" />
            <div className="cart-product-action-container">
                <button className="btn remove-btn" onClick={() => removeFromCart(p.id)}>
                <i className="fa fa-trash-o" aria-hidden="true"></i>
                </button>
                {actionButton &&
                    <button className="btn action-btn" onClick={openContactForm}>
                    <NeuroMessage id={actionTextId} tagName="span" />
                    </button>
                }
                {applyButton &&
                    <button className="btn action-btn" onClick={() => openProductActionUrl(p.id)}>
                    <NeuroMessage id={actionTextId} tagName="span" />
                    </button>
                }
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return <Modal
    show={ active }
    className={`${className} cartModal`}
    title={ <h1>{intl.formatMessage({ id: 'summary.yourCart' })}</h1> }
    onClose={ onCloseModal }
    nodeId="root"
    closeBtn={ <i className="fa fa-close"/> }
  >
    <div className="cartModal">
      {productCart.length !== 0 &&
        <div className="products-container grey-background">
            <CartSection
            titleId="summary.cart.title"
            descriptionId="summary.cart.description"
            products={productCart}
            actionTextId="summary.cart.action"
            removeFromCart={removeFromCart}
            openContactForm={()=>openContactForm(productCart)}
            actionButton={false}
            />
            <div className="cart-applyAll">
                <button className="btn" onClick={()=>openContactForm(productCart)}>
                    <NeuroMessage id="summary.cart.action" tagName="span" />
                </button>
            </div>
        </div>
        }
        <div className="products-container">
            {productCartApply.length > 0 && (
            <CartSection
                titleId="summary.cart.start"
                descriptionId="summary.cart.startDescription"
                products={productCartApply}
                actionTextId="summary.cart.startAction"
                removeFromCart={removeFromCart}
                applyButton={true}
            />
            )}
            {productCartContact.length > 0 && (
            <CartSection
                titleId="summary.cart.contact"
                descriptionId="summary.cart.contactDescription"
                products={productCartContact}
                actionTextId="summary.cart.contactAction"
                removeFromCart={removeFromCart}
                openContactForm={()=>openContactForm(productCartContact)}
                actionButton={true}
            />
            )}
        </div>
    </div>
  </Modal>;
};

export default CartModal;